module.exports = __webpack_public_path__ + "assets/thumb-express@2x.b5d98066.png";